import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/giftcard.css"
import Checkbox from '../Components/Checkbox.js';
import AppointmentService from '../utils/AppointmentService.js';
import Modal from 'react-modal';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class GiftcardMenu extends Component {
    constructor(props) {
      super(props)
      this.state = {
        images: [],
        redeemModalOpen: false,
        giftcardCode: '',
        width: document.body.clientWidth,
        color: null,
        open:false,
        message: null
      }
      this.ApptService = new AppointmentService()
          this.updateDimensions = this.updateDimensions.bind(this)
    }
    componentDidMount() {
      window.addEventListener("resize", this.updateDimensions);
      localStorage.removeItem('amount')
      localStorage.removeItem('image_id')
      localStorage.removeItem('message')
      localStorage.removeItem('sendAt')
      localStorage.removeItem('name')
      localStorage.removeItem('phone')
      this.ApptService.giftcard_images()
      .then(res =>{
        if(res.errors){
        }
        else {
          this.setState({
            images: res.giftcard_images
          })

        }
      })
      .catch(err =>{
          throw new Error('Error getting giftcard images' + err.message);
    })
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  openModal() {
    this.setState({
      giftcardCode: '',
      open: false,
      redeemModalOpen: true
    })
  }
  redeemGiftcard() {
    this.ApptService.redeemGiftcard(this.state.giftcardCode)
    .then(res => {
      if(res.errors){
        this.setState({
          open: true,
          color: '#A43E42',
          errorMessage: res.errors,
          redeemModalOpen: false
        })
      }
      else if(res){
        this.setState({
          open: true,
          color: '#5FB978',
          errorMessage: "Your giftcard has been applied. Your account balance is $" + res.account_balance/100.0,
          redeemModalOpen: false
        })
      }
    })
    .catch(error => {
      throw new Error('Error redeeming giftcard' + error.message);
    })
  }
  handleChange = event => {
    this.setState({giftcardCode: event.target.value});
  }
  render() {
    var imagesHTMl= []
    if(this.state.images && this.state.images.length > 0){
      this.state.images.forEach(function(image) {
        var imageURL = image.giftcard_images.url.url
        console.log("image url", imageURL)
        imageURL = imageURL.replace('http://', 'https://')
        imagesHTMl.push(<div className="item"><Link to={`/giftcards/${image.giftcard_images.id}`}><img className="giftcardImage" src={imageURL}></img></Link></div>)

      });
    }
    const customStyles =
    this.state.width < 780 ?
    {
      content: {
        top                   : '10%',
        left                  : '10%',
        right                 : '10%',
        bottom                : 'auto',
      }
    }:
      {
        content: {
          top                   : '25%',
          left                  : '30%',
          right                 : '30%',
          bottom                : 'auto',
        }
      }
    return (
      <div>
        <h3 className="giftcardHeader">Select Design</h3>
        <div className="flex">
          {imagesHTMl}
        </div>
        <button className="redeemButton" onClick = {() => this.openModal()}>Redeem</button>
        <Modal
          isOpen={this.state.redeemModalOpen}
          contentLabel="Example Modal"
          style={customStyles}
          >
          <div>
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Redeem EGiftcard</h4>
            </div>
            <br></br>
            <h6>If you have a valid eGift Card, we will apply it to your available account balance</h6>
            <input value={this.state.giftcardCode} onChange={this.handleChange} className="promoInput"></input>
            <button className="btn btn-primary promoAdd" onClick={() =>this.redeemGiftcard()}>Submit</button>
            <button onClick = {() => this.setState({redeemModalOpen: false})}className="btn btn-block cancelButton2 text-center">Cancel</button>
            <h6 id="promoErrorSummary">{this.state.promoError}</h6>
          </div>
        </Modal>
        <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
      </div>
    )
}
}
export default GiftcardMenu



// WEBPACK FOOTER //
// ./src/Components/GiftcardMenu.js